import { BookletMap_Entity } from "../entities/bookletMap";
import { rhapsodyApi } from "./api";

export const missionEndpoints = rhapsodyApi.injectEndpoints({
  endpoints: (build) => ({
    getPublicBooklet: build.query<BookletMap_Entity, string>({
      query: (token) => `booklets/public/${token}`,
      providesTags: ["booklet"],
    }),
  }),
});

export const { useGetPublicBookletQuery } = missionEndpoints;

export default missionEndpoints;
